/**
 * @voltxampere/ui — DPDT mechanical relay 12V coil (Sprint 44-5, placeholder)
 *
 * PLACEHOLDER. Mekanik DPDT röle — endüstriyel kontrol panel
 * standardı. Coil 12V DC / 30 mA + 2× SPDT contact (6 pin output).
 * Multi-pin physical layout Sprint 47+'da composition.
 *
 * Reference: Tyco/Omron MY2N-D2 — PCB-mount + DIN rail. Coil
 * 12 V DC, 30 mA. 2× SPDT (DPDT) contact, 5 A @ 250 VAC. PLC
 * çıkış kartı + motor reversing + dual circuit polarite.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType (output contacts tek-kanal placeholder).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const relayDpdt12v = {
    id: "relay-dpdt-12v",
    nameTr: "Röle DPDT 12V Coil (Omron MY2N-D2, placeholder)",
    nameEn: "Relay DPDT 12V Coil (Omron MY2N-D2, placeholder)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "K",
    defaultValue: "DPDT-12V",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=relay-dpdt-12v.js.map